// extracted by mini-css-extract-plugin
export var closeButton = "_os-2";
export var closeButtonIcon = "_os-3";
export var lightboxContent = "_os-1";
export var lightboxOverlay = "_os-0";